<template>
  <div>
    <v-btn text class="text-button-edit" @click="dialog = true">
      <img src="/images/icons/edit_user.svg" alt="delete-user-confirm"
             style="vertical-align: middle; margin-right: 4px;  max-width: 26px;"/>
      เปลี่ยนรหัสผ่าน
    </v-btn>
    <v-dialog v-model="dialog" max-width="500">
      <v-card class="pt-5">
        <v-card-title class="headline" style="font-weight: bold">เปลี่ยนรหัสผ่านของคุณ</v-card-title>
        <v-card-text>
          <div class="tw-border tw-rounded-lg tw-mb-5">
            <ul class="tw-table tw-cursor-pointer tw-pl-0 tw-text-lg tw-w-full tw-font-bold">
              <li class="tw-py-2 tw-px-6 tw-table-cell tw-w-6/12 tw-text-center" :class="resetPasswordTab === 'new_password' && 'tw-bg-light-green tw-text-white tw-rounded-lg'" @click="changeTab('new_password')">กำหนดรหัสผ่านใหม่</li>
              <li class="tw-py-2 tw-px-6 tw-table-cell tw-w-6/12 tw-text-center" :class="resetPasswordTab === 'forgot_password' && 'tw-bg-light-green tw-text-white tw-rounded-lg'" @click="changeTab('forgot_password')">ลืมรหัสผ่าน</li>
            </ul>
          </div>
          <form-reset-password v-if="resetPasswordTab === 'new_password'" :closeDialog="closeDialog" :dialog="dialog"></form-reset-password>
          <form-forgot-password v-if="resetPasswordTab === 'forgot_password'" :closeDialog="closeDialog" :dialog="dialog"></form-forgot-password>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import FormResetPassword from "./form-reset-password"
import FormForgotPassword from "./form-forgot-password"

export default {
  name: 'ResetPassword',
  components:{
    FormResetPassword,
    FormForgotPassword
  },
  data() {
    return {
      dialog: false,
      resetPasswordTab: 'new_password' // new_password, forgot_password
    }
  },
  methods: {
    closeDialog: function () {
      this.dialog = false
    },
    changeTab: function (type) {
      this.resetPasswordTab = type
      this.$store.dispatch('user/setChangePasswordStatus', {status: ""})
    }
  },
}
</script>

<style lang="scss">
.v-application .headline {
  font-family: "Noto Sans Thai", "Noto Sans", sans-serif !important;
}

.v-dialog {
  overflow-y: visible;
}
</style>
